/* Gogo Language Texts

Table of Contents

01.General
02.User Login, Logout, Register
03.Menu
04.Dashboards
05.Pages
06.Applications
  06.01.Chat
  06.02.Survey
  06.03.Todo
07.UI
  07.01.Alerts
  07.02.Badges
  07.03.Buttons
  07.04.Cards
  07.05.Carousel
  07.06.Charts
  07.07.Collapse
  07.08.Dropdowns
  07.09.Editors
  07.10.Forms
  07.11.Form Components
  07.12.Icons
  07.13.Input Groups
  07.14.Jumbotron
  07.15.Modal
  07.16.Navigation
  07.17.Popover & Tooltip
  07.18.Sortable
  07.19.Maps
  07.20.Tables
*/

const koMessages = {
  /* 01.General */
  'general.copyright': 'Myma.ai © 2019 All Rights Reserved.',

  /* 02.User Login, Logout, Register */
  'user.login-title': 'Login',
  'user.register': 'Register',
  'user.forgot-password': 'Forgot Password',
  'user.email': 'E-mail',
  'user.newpassword': 'New Password',
  'user.currentpassword': 'Current Password',
  'user.newpasswordagain': 'New Password Again',
  'user.password': 'Password',
  'user.forgot-password-question': 'Forget password?',
  'user.fullname': 'Full Name',
  'user.firstname': 'First Name',
  'user.lastname': 'Last Name',
  'user.login-button': 'LOGIN',
  'user.register-button': 'REGISTER',
  'user.reset-password-button': 'RESET',
  'user.buy': 'BUY',
  'user.username': 'Username',

  /* 03.Menu */
  'menu.app': 'Home',

  'menu.default': 'Default',
  'menu.analytics': 'Analytics',
  'menu.ecommerce': 'Ecommerce',
  'menu.content': 'Content',
  'menu.pages': 'Pages',
  'menu.data-list': 'Data List',
  'menu.thumb-list': 'Thumb List',
  'menu.image-list': 'Image List',
  'menu.details': 'Details',
  'menu.search': 'Search',
  'menu.login': 'Login',
  'menu.register': 'Register',
  'menu.forgot-password': 'Forgot Password',
  'menu.error': 'Error',
  'menu.applications': 'Applications',
  'menu.todo': 'To-do List',
  'menu.survey': 'Survey',
  'menu.chat': 'Chat',
  'menu.ui': 'UI',
  'menu.edit': 'Edit',
  'menu.alerts': 'Alerts',
  'menu.badges': 'Badges',
  'menu.buttons': 'Buttons',
  'menu.cards': 'Cards',
  'menu.carousel': 'Carousel',
  'menu.charts': 'Charts',
  'menu.collapse': 'Collapse',
  'menu.dropdowns': 'Dropdowns',
  'menu.editors': 'Editors',
  'menu.form-layouts': 'Form Layouts',
  'menu.form-components': 'Form Components',
  'menu.form-validations': 'Form Validations',
  'menu.icons': 'Icons',
  'menu.input-groups': 'Input Groups',
  'menu.jumbotron': 'Jumbotron',
  'menu.modal': 'Modal',
  'menu.navigation': 'Navigation',
  'menu.popover-tooltip': 'Popover & Tooltip',
  'menu.sortable': 'Sortable',
  'menu.tables': 'Tables',
  'menu.menu': 'Menu',
  'menu.subhidden': 'Subhidden',
  'menu.hidden': 'Hidden',
  'menu.visible': 'Visible',
  'menu.maps': 'Maps',
  'menu.landingpage': 'Landing Page',
  'menu.multipage-home': 'Multipage Home',
  'menu.singlepage-home': 'Singlepage Home',
  'menu.about': 'About',
  'menu.auth-login': 'Auth Login',
  'menu.auth-register': 'Auth Register',
  'menu.blog': 'Blog',
  'menu.blog-detail': 'Blog Detail',
  'menu.careers': 'Careers',
  'menu.confirmation': 'Confirmation',
  'menu.contact': 'Contact',
  'menu.docs': 'Docs',
  'menu.features': 'Features',
  'menu.prices': 'Prices',
  'menu.videos': 'Videos',
  'menu.mailing': 'Mailing',
  'menu.invoice': 'Invoice',
  'menu.blank-page': 'Coming soon...',
  'menu.types': 'Menu Types',
  'menu.levels': 'Menu Levels',
  'menu.third-level-1': 'Third Level 1',
  'menu.third-level-2': 'Third Level 2',
  'menu.third-level-3': 'Third Level 3',

  /* 04.Dashboards */
  'dashboards.update': '업데이트',
  'dashboards.save': '저장',
  'dashboards.pending-orders': 'Pending Orders',
  'dashboards.completed-orders': 'Completed Orders',
  'dashboards.refund-requests': 'Refund Requests',
  'dashboards.new-comments': 'New Comments',
  'dashboards.sales': 'Sales',
  'dashboards.orders': 'Orders',
  'dashboards.refunds': 'Refunds',
  'dashboards.recent-orders': 'Recent Orders',
  'dashboards.product-categories': 'Product Categories',
  'dashboards.cakes': 'Cakes',
  'dashboards.tickets': '티켓',
  'dashboards.calendar': 'Calendar',
  'dashboards.best-sellers': 'Best Sellers',
  'dashboards.per-session': 'Per Session',
  'dashboards.profile-status': 'Profile Status',
  'dashboards.payment-status': 'Payment Status',
  'dashboards.work-progress': 'Work Progress',
  'dashboards.tasks-completed': 'Tasks Completed',
  'dashboards.payments-done': 'Payments Done',
  'dashboards.order-stock': 'Order - Stock',
  'dashboards.categories': 'Categories',
  'dashboards.quick-post': 'Quick Post',
  'dashboards.title': 'Title',
  'dashboards.content': 'Content',
  'dashboards.ticket-count': '티켓 수',
  'dashboards.commonticketsubmission': '일반적인 티켓 제출',
  'dashboards.category': 'Category',
  'dashboards.save-and-publish': 'Save and Publish',
  'dashboards.top-viewed-posts': 'Top Viewed Posts',
  'dashboards.posts': 'Posts',
  'dashboards.pending-for-publish': 'Pending for publish',
  'dashboards.users': 'Users',
  'dashboards.on-approval-process': 'On approval process',
  'dashboards.alerts': 'Alerts',
  'dashboards.waiting-for-notice': 'Waiting for notice',
  'dashboards.files': 'Files',
  'dashboards.pending-for-print': 'Pending for print',
  'dashboards.logs': 'Logs',
  'dashboards.gogo': 'GOGO',
  'dashboards.magic-is-in-the-details': 'MAGIC IS IN THE DETAILS',
  'dashboards.yes-it-is-indeed': 'Yes, it is indeed!',
  'dashboards.advanced-search': 'Advanced Search',
  'dashboards.toppings': 'Toppings',
  'dashboards.type': 'Type',
  'dashboards.keyword': 'Keyword',
  'dashboards.search': 'Search',
  'dashboards.top-rated-items': 'Top Rated Items',
  'dashboards.country': '국가',
  'dashboards.webVisitors': '웹 방문자',
  'dashboards.avatarClicks': '아바타 클릭',
  'dashboards.wordCloud': '단어 구름',
  'dashboards.topic': '주제',
  'dashboards.name': '이름',
  'dashboards.button': '버튼',
  'dashboards.visits': '방문',
  'dashboards.checkAvailability': '이용 가능 여부 또는 요금 확인',
  'dashboards.details': '세부',
  'dashboards.roomsAvailability': '객실 및 이용 가능 여부',
  'dashboards.startChat': '채팅 시작',
  'dashboards.restaurantsBars': '레스토랑 및 바',
  'dashboards.groupBooking': '단체 예약',
  'dashboards.promotions': '프로모션',
  'dashboards.weedingevents': '결혼 & 이벤트',
  'dashboards.lostsomething': '무언가를 잃어버림',
  'dashboards.producttext': '제품 텍스트',
  'dashboards.bookingroomnew': '새 방 예약',
  'dashboards.email': '이메일',
  'dashboards.phone': '전화',
  'dashboards.zipcode': '우편번호',
  'dashboards.marketingconsent': '마케팅 동의',
  'dashboards.additionalinfo': '추가 정보',
  'dashboards.viewallcontacts': '모든 연락처 보기',
  'dashboards.current': '현재',
  'dashboards.last7days': '지난 7일',
  'dashboards.last30days': '지난 30일',
  'dashboards.thisweek': '이번 주',
  'dashboards.thismonth': '이번 달',
  'dashboards.previousmonth': '이전 달',
  'dashboards.yeartodate': '올해 누계',
  'dashboards.lastyear': '작년',
  'dashboards.all': '전체',
  'dashboards.standardOccupancy': '기준 수용 인원',
  'dashboards.max-occupancy': '최대 수용 인원',
  'dashboards.numberOfThisType': '이 유형의 수',
  'dashboards.displayOrder': '표시 순서',
  'dashboards.provider': '제공자',
  'dashboards.edit': '편집',
  'dashboards.delete': '삭제',
  'dashboards.addImages': '이미지 추가',
  'dashboards.location_ip': 'IP 주소를 기반으로 추정된 위치',
  'dashboards.near': '근처',
  'dashboards.referral': '이 웹사이트를 통해 귀하의 페이지에 유입된 사용자',
  'dashboards.calling_party': '발신 사용자',
  'dashboards.called_party': '착신 사용자',
  'dashboards.lastdial': '최근 통화',
  'dashboards.imagelink': '이미지 링크',
  'dashboards.browsegallery': '갤러리 보기',
  'dashboards.changelog': '변경 로그',
  'dashboards.externalresources': '외부 리소스',
  'dashboards.webpage': '웹 페이지',
  'dashboards.web-pages': '웹 페이지',
  'dashboards.published': '게시됨',
  'dashboards.adddocument': '문서 추가',
  'dashboards.ready-to-publish': '게시 준비 완료',
  'dashboards.draft': '초안',
  'dashboards.order-by': '정렬 기준',
  'dashboards.add-faq': 'FAQ 추가',
  'dashboards.collections': '컬렉션',
  'dashboards.items': '항목',
  'dashboards.rooms-availability': '객실 및 이용 가능 여부',
  'dashboards.events-wedding-venues': '이벤트 및 웨딩 장소',
  'dashboards.long-stay-enquiry': '장기 숙박 문의',
  'dashboards.reservation-confirmation-request': '예약 확인 요청',
  'dashboards.modify-cancel-booking': '예약 수정 또는 취소',
  'dashboards.left-something-behind': '물건을 두고 왔어요',
  'dashboards.invoice-copy': '청구서 / 영수증 사본',
  'dashboards.sync': '동기화',
  'dashboards.add-web-page': '웹 페이지 추가',
  'dashboards.sprint-title': 'Sprint를 소개합니다—AI 모델을 10배 빠르게 학습시키는 획기적인 자동화 기능입니다.',
  'dashboards.sprint-description': 'Sprint는 함께 작동하여 창의력을 발휘하고 생산성을 높이며 디지털 어시스턴트 학습에 걸리는 시간을 획기적으로 단축시킵니다.',
  'dashboards.sprint-feature': 'Sprint 기능은 외부 소스의 지식을 동기화하도록 설계되어 초기 설정과 지속적인 데이터 업데이트 모두에 유용합니다. 활성 시스템에서 실행될 경우, 구성한 외부 소스를 기반으로 Knowledge Hub를 수정하여 AI 생성 동작 및 응답에 직접 영향을 미칠 수 있습니다. Sprint 설정 관련 도움은 지원팀에 문의해 주세요.',
  'dashboards.change-password': '비밀번호 변경',
  'dashboards.sign-out': '로그아웃',
  'dashboards.privacy-policy': '개인정보 처리방침',
  'dashboards.help-center': '도움말 센터',
  'dashboards.switch-account': '계정 전환',
  'dashboards.business-settings': '비즈니스 설정',
  'dashboards.notifications-allowed': '알림 허용됨',
  'dashboards.dark-theme': '다크 테마',
  'dashboards.online': '온라인',
  'dashboards.offline': '오프라인',
  'dashboards.invoice-&-payments': '청구서 및 결제',
  'dashboards.upgrade-plan': '요금제 업그레이드',
  'dashboards.add-room': '객실 추가',
  'dashboards.room-type': '객실 유형',
  'dashboards.room-name': '객실 이름',
  'dashboards.how-many-guests': '이 객실에는 몇 명이 머물 수 있나요?',
  'dashboards.number-of-rooms-this-type': '객실 수 (이 유형)',
  'dashboards.number-of-bedrooms': '침실 수',
  'dashboards.number-of-livingrooms': '거실 수',
  'dashboards.minimum-adults': '최소 성인 수',
  'dashboards.maximum-adults': '최대 성인 수',
  'dashboards.maximum-children': '최대 어린이 수',
  'dashboards.maximum-infants': '최대 유아 수',
  'dashboards.extra-beds-allowed': '추가 침대 허용',
  'dashboards.booking-engine-code': '예약 엔진 코드',
  'dashboards.room-size': '객실 크기',
  'dashboards.balcony-area': '발코니 면적',
  'dashboards.unit': '단위',
  'dashboard.whatsapp_message': '여기에 메시지를 입력하세요...',
  'dashboard.whatsapp_reply_window': 'WhatsApp Business에서 고객이 마지막으로 메시지를 보낸 시점부터 24시간 이내에 응답할 수 있습니다. 이 24시간 고객 응대 창 내에서 응답하면 모든 유형의 메시지를 보낼 수 있습니다. 24시간이 지나면 사전 승인된 메시지 템플릿만 전송할 수 있으며, 고객이 응답하면 24시간 창이 다시 시작됩니다.',
  'dashboards.square-meters': '제곱미터',
  "dashboard.pick_quick_reply": "빠른 답장을 선택하거나 메시지를 입력하세요",
  "dashboard.hang_in_there": "연결하는 동안 잠시만 기다려 주세요!",
  "dashboard.outbound_msg": "발신 메시지 전송 시점",
  "dashboard.message_sent": "메시지가 성공적으로 전송되었습니다!",
  "dashboard.failed_msg": "메시지 전송 실패",
  "dashboard.new_chat_message": "새 채팅 메시지",
  "dashboard.user_msg": "지난 24시간 이내에 사용자 메시지가 있습니다. 어떤 메시지로든 답장할 수 있습니다. 이 템플릿 메시지를 계속 보내시겠습니까, 아니면 다른 메시지로 답장하시겠습니까?",
  "dashboard.us_number": "Meta가 2025년 4월 1일부로 미국 번호로의 모든 마케팅 메시지를 중단했기 때문에 WhatsApp Business 메시지는 미국 번호로 전송되지 않습니다.",
  "dashboard.error_msg": "모든 자리표시자를 올바르게 입력해 주세요.",


  'web-widget.title': '웹사이트 챗봇용 위젯 메뉴',
  /*Home page*/
  'dashboards.quickstartwithai': 'AI로 빠른 시작',
  'dashboards.fastestpathtoautomation': 'AI 도구로 자동화로 가는 가장 빠른 경로에 있습니다',
  'dashboards.insightsthatempower': '권한을 부여하는 인사이트',
  'dashboards.trainchatbot': '챗봇 훈련',
  'dashboards.automatewithforms': '폼으로 자동화',
  'dashboards.inroomdigitalcompendium': '객실 내 디지털 안내집',
  'dashboards.support': '지원',
  'dashboards.helpcenter': '도움말 센터',
  'dashboards.searchfaqintegrations': '자주 묻는 질문, 통합 등과 관련된 문서를 검색하세요.',
  'dashboards.asklivechat': '라이브 채팅으로 팀에 질문하기',
  'dashboards.inroomqrcode': '객실 내 QR 코드로 숙소 및 위치 정보 보기',
  'dashboards.customizewebwidget': '통합된 AI 챗봇과 함께 웹 위젯을 사용자화하여 사이트에 추가',
  'dashboards.createcustomforms': '맞춤 양식을 만들어 게스트가 제출하면 알림 받기',
  'dashboards.trainchatbotproperty': '체크인 시간, 액티비티 등 숙소 정보를 사용해 챗봇 학습',
  'dashboards.chatbotinsights': '챗봇이 게스트와 어떻게 상호 작용하는지 확인하고 웹사이트 방문자, 자주 묻는 질문 등 통계 인사이트 얻기',
  'dashboards.addaichatbottoyourwebsite': '웹사이트에 AI 챗봇 추가',

  /* Email Stats */
  'dashboards.thread-summary-title': '스레드 요약',
  'dashboards.thread-summary-subtitle': 'AI가 생성한 이메일 요약',
  'dashboards.ai-replies-title': 'AI 응답',
  'dashboards.ai-replies-subtitle': 'AI가 생성한 응답',
  'dashboards.total-thread-summary-title': '생성된 스레드 요약 총합',
  'dashboards.total-ai-replies-title': '생성된 AI 응답 총합',
  'dashboards.total-draft-copied': '사용자가 복사한 초안',
  'dashboards.urgency': '긴급도',
  'dashboards.sentiment': '감정',
  'dashboards.common-email-reasons': '자주 쓰이는 이메일 이유',
  'dashboards.topics-in-emails': '이메일 내 주제',
  'dashboards.email-assistant-usage': 'AI 이메일 어시스턴트 사용량',
  'dashboards.usage-by-email-address': '이메일 주소별 사용량',


  /* 05.Pages */
  'pages.title.dashboards.analytics': 'Analytics',
  'pages.title.ari': 'Availability and Rates',
  'pages.title.conversations': 'Conversations',
  'pages.title.bookings': 'Reservations and Bookings',
  'pages.title.tickets': 'Leads and Tickets',
  'pages.title.propinfo': 'Responses',
  'pages.title.discounts': 'Discounts and Promotions',
  'pages.title.finance': 'Finance',
  'pages.title.integration': 'Integration',
  'pages.title.admin': 'Admin',
  'pages.add-new': 'ADD NEW',
  'pages.add-new-modal-title': 'Add New Item',
  'pages.display-options': 'Display Options',
  'pages.orderby': 'Order By : ',
  'pages.product-name': 'Product Name',
  'pages.category': 'Category',
  'pages.description': 'Description',
  'pages.status': 'Status',
  'pages.cancel': 'Cancel',
  'pages.submit': 'Submit',
  'pages.delete': 'Delete',
  'pages.another-action': 'Another action',
  'pages.actions': 'ACTIONS',
  'pages.header': 'Header',
  'pages.details': 'DETAILS',
  'pages.orders': 'ORDERS',
  'pages.rating': 'Rating',
  'pages.price': 'Price',
  'pages.ingredients': 'Ingredients',
  'pages.is-vegan': 'Is Vegan',
  'pages.order-status': 'Order Status',
  'pages.bake-progress': 'Bake Progress',
  'pages.popularity': 'Popularity',
  'pages.comments': 'Comments',
  'pages.error-title': 'Ooops... looks like an error occurred!',
  'pages.error-code': 'Error code',
  'pages.go-back-home': 'GO BACK HOME',
  'pages.mailing-info':
    'Mailing templates use inline styling and table layout to be displayed well at various service providers. To provide better usability we include it as regular html with dangerouslySetInnerHTML.',
  'pages.invoice-info':
    'Invoice template has an inline styled version for usage outside of the project as well as React version.',
  'pages.react-version': 'React Version',
  'pages.inline-version': 'Inline Styled Html Version',

  /* 06.Applications */

  /* 06.01.Chat */
  'chat.messages': '메시지',
  'chat.contacts': '콘택트 렌즈',
  'chat.saysomething': '뭐라고..',

  /* 06.02.Survey */
  'survey.delete': 'Delete',
  'survey.edit': 'Edit',
  'survey.add-new': 'ADD NEW',
  'survey.add-new-title': 'Add New Survey',
  'survey.title': 'Title',
  'survey.category': 'Category',
  'survey.label': 'Label',
  'survey.status': 'Status',
  'survey.cancel': 'Cancel',
  'survey.submit': 'Submit',
  'survey.another-action': 'Another action',
  'survey.display-options': 'Display Options',
  'survey.orderby': 'Order By : ',
  'survey.all-surveys': 'All Surveys',
  'survey.completed-surveys': 'Completed Surveys',
  'survey.categories': 'Categories',
  'survey.active-surveys': 'Active Surveys',
  'survey.labels': 'Labels',

  /* 06.03.Todo */
  'todo.add-new': 'ADD NEW',
  'todo.add-new-title': 'Add New Todo',
  'todo.title': 'Title',
  'todo.detail': 'Detail',
  'todo.category': 'Category',
  'todo.label': 'Label',
  'todo.status': 'Status',
  'todo.cancel': 'Cancel',
  'todo.submit': 'Submit',
  'todo.action': 'Action',
  'todo.another-action': 'Another action',
  'todo.display-options': 'Display Options',
  'todo.orderby': 'Order By : ',
  'todo.all-tasks': 'All Tasks',
  'todo.pending-tasks': 'Pending Tasks',
  'todo.completed-tasks': 'Completed Tasks',
  'todo.categories': 'Categories',
  'todo.labels': 'Labels',

  /* 07.UI */

  /* 07.01.Alerts */
  'alert.rounded': 'Rounded Alert',
  'alert.react-notifications': 'React Notifications',
  'alert.outline': 'Outline',
  'alert.primary': 'Primary',
  'alert.secondary': 'Secondary',
  'alert.info': 'Info',
  'alert.success': 'Success',
  'alert.warning': 'Warning',
  'alert.error': 'Error',
  'alert.filled': 'Filled',
  'alert.primary-text': 'This is a primary alert—check it out!',
  'alert.secondary-text': 'This is a secondary alert—check it out!',
  'alert.success-text': 'This is a success alert—check it out!',
  'alert.danger-text': 'This is a danger alert—check it out!',
  'alert.warning-text': 'This is a warning alert—check it out!',
  'alert.info-text': 'This is a info alert—check it out!',
  'alert.light-text': 'This is a light alert—check it out!',
  'alert.dark-text': 'This is a dark alert—check it out!',
  'alert.default': 'Default Alert',
  'alert.dismissing': 'Dismissing Alert',
  'alert.dismissing-text':
    'Holy guacamole! You should check in on some of those fields below.',
  'alert.dismissing-without-animate-text':
    'I am an alert and I can be dismissed without animating!',

  /* 07.02.Badges */
  'badge.sizes': 'Sizes',
  'badge.colors': 'Colors',
  'badge.outline': 'Outline',
  'badge.links': 'Links',
  'badge.counter-badges': 'Counter Badges',
  'badge.bootstrap-default': 'Bootstrap Default',
  'badge.primary': 'Primary',
  'badge.secondary': 'Secondary',
  'badge.success': 'Success',
  'badge.danger': 'Danger',
  'badge.warning': 'Warning',
  'badge.info': 'Info',
  'badge.light': 'Light',
  'badge.dark': 'Dark',

  /* 07.03.Buttons */
  'button.default': 'Bootstrap Default',
  'button.colors': 'Colors',
  'button.rounded': 'Rounded',
  'button.outline': 'Outline',
  'button.states': 'States',
  'button.sizes': 'Sizes',
  'button.button-groups': 'Button Groups',
  'button.large-button': 'Large Button',
  'button.small-button': 'Small Button',
  'button.extra-small-button': 'Extra Small Button',
  'button.block-button': 'Block Button',
  'button.active': 'Active',
  'button.disabled': 'Disabled',
  'button.basic': 'Basic',
  'button.toolbar': 'Toolbar',
  'button.nesting': 'Nesting',
  'button.vertical-variation': 'Vertical Variation',
  'button.checkbox-radio-button': 'Checkbox and Radio Button',
  'button.checkbox': 'Checkbox',
  'button.radio': 'Radio',
  'button.radio-button': 'Radio Button',
  'button.primary': 'Primary',
  'button.secondary': 'Secondary',
  'button.success': 'Success',
  'button.danger': 'Danger',
  'button.warning': 'Warning',
  'button.info': 'Info',
  'button.light': 'Light',
  'button.dark': 'Dark',
  'button.states-text':
    'This button shows a spinner for 2 seconds and an error icon for 3 seconds before switching to normal state. This states can be triggered by adding and removing classes.',
  'button.click-here': 'Click Here',
  'button.states-text-alternate':
    'This button shows a spinner for 2 seconds and an error icon for 3 seconds before switching to normal state. This states can be triggered by adding and removing classes.',
  'button.primary-link': 'Primary Link',
  'button.link': 'Link',
  'button.primary-button': 'Primary Button',
  'button.button': 'Button',
  'button.left': 'Left',
  'button.middle': 'Middle',
  'button.right': 'Right',
  'button.dropdown': 'Dropdown',
  'button.dropdown-link': 'Dropdown Link',

  /* 07.04.Cards */
  'cards.icon-card': 'Icon Card',
  'cards.image-card': 'Image Card',
  'cards.image-overlay-card': 'Image Overlay Card',
  'cards.image-card-list': 'Image Card List',
  'cards.tab-card': 'Tab Card',
  'cards.user-card': 'User Card',

  /* 07.05.Carousel */
  'carousel.basic': 'Carousel Basic',
  'carousel.single': 'Carousel Single',
  'carousel.without-controls': 'Carousel Without Controls',

  /* 07.06.Charts */
  'charts.line': 'Line Chart',
  'charts.polar': 'Polar Chart',
  'charts.area': 'Area Chart',
  'charts.scatter': 'Scatter Chart',
  'charts.bar': 'Bar Chart',
  'charts.radar': 'Radar Chart',
  'charts.pie': 'Pie Chart',
  'charts.doughnut': 'Doughnut Chart',
  'charts.shadow': 'Shadow',
  'charts.no-shadow': 'No Shadow',

  /* 07.07.Collapse */
  'collapse.basic': 'Basic',
  'collapse.toggle': 'Toggle',
  'collapse.accordion': 'Accordion',
  'collapse.controlled': 'Controlled',
  'collapse.uncontrolled': 'Uncontrolled',

  /* 07.08.Dropdowns */
  'dropdowns.basic': 'Basic',
  'dropdowns.controlled': 'Controlled',
  'dropdowns.uncontrolled': 'Uncontrolled',
  'dropdowns.dropdown': 'Dropdown',
  'dropdowns.header': 'Header',
  'dropdowns.action': 'Action',
  'dropdowns.another-action': 'Another Action',
  'dropdowns.right': 'Right',
  'dropdowns.left': 'Left',
  'dropdowns.drop-directions': 'Drop Directions',
  'dropdowns.dropright': 'Dropright',
  'dropdowns.dropleft': 'Dropleft',
  'dropdowns.small-button': 'Small Button',
  'dropdowns.large-button': 'Large Button',
  'dropdowns.sizing': 'Sizing',
  'dropdowns.split-button': 'Split Button Dropdowns',
  'dropdowns.dropup': 'Dropup',

  /* 07.09.Editors */
  'editors.draftjs': 'Draft.js',
  'editors.quill-standart': 'Quill Standard',
  'editors.quill-bubble': 'Quill Bubble',

  /* 07.10.Forms */
  'forms.basic': 'Basic',
  'forms.email': 'E-mail',
  'forms.email-muted': "We'll never share your email with anyone else.",
  'forms.password': 'Password',
  'forms.submit': 'Submit',
  'forms.horizontal': 'Horizontal',
  'forms.radios': 'Radios',
  'forms.first-radio': 'First radio',
  'forms.second-radio': 'Second radio',
  'forms.third-radio-disabled': 'Third disabled radio',
  'forms.checkbox': 'Checkbox',
  'forms.signin': 'Sign in',
  'forms.top-labels-over-line': 'Top Labels Over Line',
  'forms.tags': 'Tags',
  'forms.date': 'Date',
  'forms.state': 'State',
  'forms.top-labels-in-input': 'Top Labels In Input',
  'forms.email-u': 'E-MAIL',
  'forms.password-u': 'PASSWORD',
  'forms.tags-u': 'TAGS',
  'forms.date-u': 'DATE',
  'forms.state-u': 'STATE',
  'forms.grid': 'Form Grid',
  'forms.address': 'Address',
  'forms.address2': 'Address 2',
  'forms.city': 'City',
  'forms.city-message': 'Please select a city!',
  'forms.state-message': 'Please select a state!',
  'forms.zip': 'Zip',
  'forms.signup': 'Signup',
  'forms.inline': 'Inline',
  'forms.validation-availity': 'Availity Reactstrap Validation',
  'forms.validation-formik': 'Formik Validation',
  'forms.default': 'Default',
  'forms.firstname': 'First name',
  'forms.firstname-message': 'Please enter your first name!',
  'forms.lastname': 'Last name',
  'forms.lastname-message': 'Please enter your last name!',

  /* 07.11.Form Components */
  'form-components.custom-inputs': 'Custom Inputs',
  'form-components.checkboxes': 'Checkboxes',
  'form-components.radios': 'Radios',
  'form-components.inline': 'Inline',
  'form-components.react-select': 'React Select',
  'form-components.state-single': 'State Single',
  'form-components.state-multiple': 'State Multiple',
  'form-components.react-autosuggest': 'React Autosuggest',
  'form-components.date-picker': 'Date Picker',
  'form-components.date': 'Date',
  'form-components.date-range': 'Date Range',
  'form-components.date-with-time': 'Date with Time',
  'form-components.embedded': 'Embedded',
  'form-components.dropzone': 'Dropzone',
  'form-components.drop-files-here': 'Drop Files Here',
  'form-components.tags': 'Tags',
  'form-components.switch': 'Switch',
  'form-components.primary': 'Primary',
  'form-components.secondary': 'Secondary',
  'form-components.primary-inverse': 'Primary Inverse',
  'form-components.secondary-inverse': 'Secondary Inverse',
  'form-components.slider': 'Slider',
  'form-components.double-slider': 'Double Slider',
  'form-components.single-slider': 'Single Slider',
  'form-components.rating': 'Rating',
  'form-components.interactive': 'Interactive',
  'form-components.readonly': 'Readonly',
  'form-components.type-a-cake': 'Type a Cake',
  'form-components.start': 'Start',
  'form-components.end': 'End',
  'form-components.tables': 'Tables',
  /* 07.12.Icons */
  'icons.simplelineicons': 'Simple Line Icons',
  'icons.iconsmind': 'Iconsmind Icons',

  /* 07.13.Input Groups */
  'input-groups.basic': 'Basic',
  'input-groups.sizing': 'Sizing',
  'input-groups.small': 'Small',
  'input-groups.default': 'Default',
  'input-groups.large': 'Large',
  'input-groups.checkboxes-and-radios': 'Checkboxes and radios',
  'input-groups.multiple-inputs': 'Multiple Inputs',
  'input-groups.first-and-last-name': 'First and last name',
  'input-groups.multiple-addons': 'Multiple Addons',
  'input-groups.button-addons': 'Button Addons',
  'input-groups.button': 'Button',
  'input-groups.buttons-with-dropdowns': 'Buttons with Dropdowns',
  'input-groups.dropdown': 'Dropdown',
  'input-groups.header': 'Header',
  'input-groups.action': 'Action',
  'input-groups.another-action': 'Another Action',
  'input-groups.custom-select': 'Custom Select',
  'input-groups.options': 'Options',
  'input-groups.choose': 'Choose...',
  'input-groups.custom-file-input': 'Custom File Input',

  /* 07.14.Jumbotron */
  'jumbotron.hello-world': 'Hello, world!',
  'jumbotron.lead':
    'This is a simple hero unit, a simple jumbotron-style component for calling extra attention to featured content or information.',
  'jumbotron.lead-detail':
    'It uses utility classes for typography and spacing to space content out within the larger container.',
  'jumbotron.learn-more': 'Learn more',

  /* 07.15.Modal */
  'modal.basic': 'Basic',
  'modal.modal-title': 'Modal title',
  'modal.launch-demo-modal': 'Launch Demo Modal',
  'modal.scrolling-long-content': 'Scrolling Long Content',
  'modal.backdrop': 'Backdrop',
  'modal.backdrop-value': 'Backdrop value',
  'modal.right-modal': 'Right Modal',
  'modal.launch-right-modal': 'Launch Right Modal',
  'modal.nested-modal': 'Nested Modal',
  'modal.size': 'Size',
  'modal.launch-large-modal': 'Launch Large Modal',
  'modal.launch-small-modal': 'Launch Small Modal',

  /* 07.16.Navigation */
  'nav.basic': 'Nav Basic',
  'nav.active': 'Active',
  'nav.disabled': 'Disabled',
  'nav.disabled-link': 'Disabled Link',
  'nav.link': 'Link',
  'nav.longer-link': 'Longer nav link',
  'nav.another-link': 'Another Link',
  'nav.right': 'Right',
  'nav.dropdown': 'Dropdown',
  'nav.header': 'Header',
  'nav.action': 'Action',
  'nav.another-action': 'Another Action',
  'nav.horizontal-alignment': 'Nav Horizontal Alignment',
  'nav.vertical-alignment': 'Nav Vertical Alignment',
  'nav.pills': 'Nav Pills',
  'nav.fill-justify': 'Nav Fill and Justify',
  'nav.pills-dropdowns': 'Nav Pills with Dropdowns',
  'nav.pagination-basic': 'Pagination Basic',
  'nav.pagination-sizing': 'Pagination Sizing',
  'nav.large': 'Large',
  'nav.small': 'Small',
  'nav.center': 'Center',
  'nav.pagination-alignment': 'Pagination Alignment',
  'nav.breadcrumb-basic': 'Breadcrumb Basic',

  /* 07.17.Popover & Tooltip */
  'popover-tooltip.popover': 'Popover',
  'popover-tooltip.tooltip': 'Tooltip',

  /* 07.18.Sortable */
  'sortable.columns': 'Sorting Columns',
  'sortable.basic': 'Basic',
  'sortable.handles': 'Handles',

  /* 07.19.Maps */
  'maps.google': 'Google',
  'maps.yandex': 'Yandex',

  /* 07.20.Tables */
  'table.bootstrap-tables': 'Bootstrap Tables',
  'table.bootstrap-basic': 'Basic Table',
  'table.bootstrap-striped': 'Striped Rows',
  'table.bootstrap-bordered': 'Bordered Table',
  'table.bootstrap-borderless': 'Borderless Table',
  'table.bootstrap-hoverable': 'Hoverable Rows',
  'table.bootstrap-responsive': 'Responsive Table',
  'table.react-tables': 'React Tables',
  'table.react-pagination': 'Pagination',
  'table.react-scrollable': 'Scrollable',
  'table.react-advanced': 'Filter, Length and Jump',

  /* Property Info */
  "property-info.allcustomers": '모든 고객',
  'property-info.external-sources': '외부 소스',
  'property-info.faq': '자주 묻는 질문',
  'property-info.documents': '문서',
  'property-info.publish-ai': 'AI로 게시',
  'property-info.pre-built-templates': '사전 제작 템플릿',
  'property-info.room-types': '객실 유형',

  'property-info.about-property': '부동산 정보',
  'property-info.about-properties': '속성 정보',
  'property-info.facilities-services': '시설 및 서비스',
  'property-info.property-facilities': '부동산 시설',
  'property-info.room-amenities': '객실 어메니티',
  'property-info.property-contact': '부동산 연락처',
  'property-info.property-activities': '부동산 활동',
  'property-info.property-location': '부동산 위치',
  'property-info.about-rooms': '객실 소개',
  'property-info.about-sites': '사이트 정보',
  'property-info.special-emergencies': '비상 사태',
  'property-info.gallery': '갤러리',
  'property-info.policies': '정책',
  'property-info.nearby': '가까운',
  'property-info.transport': '수송',
  'property-info.location': '위치',
  'property-info.about-rhproperty': '은퇴 가정에 대해',
  'property-info.related-topics': '관련 항목',
  'property-info.assistant-options': '어시스턴트 옵션',
  'property-info.restaurant-assistant-information': '레스토랑 정보',
  'property-info.restaurant-assistant-options': '환영 메시지',
  'property-info.channel-messages': '채널 메시지',
  'property-info.icon.gallery': '아이콘 갤러리',
  'property-info.copilot': '부조종사',
  'property-info.sprint': '스프린트',
  'property-info.home-information': '홈 정보',
  'property-info.loction': '위치',
  'property-info.rooms-and-images': '객실 및 이미지',
  'property-info.trainig-data': '교육 데이터',
  'property-info.flows': '흐름',
  'property-info.add-your-own': '나만의 추가',
  'property-info-utility-miscellaneous': '여러 가지 잡다한',
  'property-info-utility-payment': '결제',
  'property-info-utility-broadband': '광대역',
  'property-info-utility-emergency': '비상',
  'property-info-utility-mobile': '이동하는',
  'property-info-utility-moving': '움직이는',
  'property-info.publishMonitor': '게시 및 모니터링',
  'property-info.webWidget': '웹 위젯',
  'property-info.media': '미디어',
  /** Rate & Promo */
  'rate-promo.rate-plans': '요금제',
  'rate-promo.rate-plan-addons': '애드온',
  'rate-promo.rate-plan-promos': '프로모션',

  'title.property-information': '부동산 정보',

  'property.message': '메세지',
  'property.example': '예시',
  'property.link': '연결',
  'property.image-carousel': '이미지 캐러셀',
  'property.Title': '제목',
  'property.SubTitle': '부제',

  'property.add-invoke-api': 'API 호출',
  'property.add-message-button': '메시지 추가',
  'property.add-img-button': '이미지 추가',
  'property.add-link-button': '링크 추가',
  'property.add-herocard-button': '영웅 카드 추가',
  'property.add-api-button': '버튼 추가',


  'menu.settings': '설정',
  'menu.workflows': '워크플로우',
  'menu.product_services': '제품 & 서비스',
  'menu.product_recommander': '제품 추천자',
  'menu.digital_guide_book': '디지털 가이드 북',
  'menu.welcome_message': '환영 메시지',
  'menu.about-property': '속성 정보',
  'menu.property-facilities': '속성 시설',
  'menu.room-amenities': '객실 편의 시설',
  'menu.property-contact': '속성 연락처',
  'menu.about-rooms': '객실 정보',
  'menu.special-emergencies': '비상 상황',
  'menu.show-filter': '필터 표시',
  'menu.new': '새로 만들기',
  'menu.channel': '채널',
  'menu.application': '애플리케이션',
  'menu.content-manager': '콘텐츠 관리자',
  'menu.events-calendar': '이벤트 캘린더',
  'menu.appearance-settings': '모양 및 설정',

  'dashboards.send': '보내기',
  'dashboards.hello': '안녕하세요',
  'dashboards.notificationsAllowed': '알림 허용됨',
  'dashboards.allowNotifications': '알림 허용',
  'dashboards.views': '조회수',
  'dashboards.bookingURL': '예약 URL',
  'dashboards.searchTags': '검색 태그',
  'dashboards.searchCategoryTags': '검색 카테고리 태그',
  'dashboards.bedroom': '침실',
  'dashboards.addBedroom': '침실 추가',
  'dashboards.frequency': '빈도',
  'dashboards.includeSubpages': '하위 페이지 포함',
  'dashboards.enableFaqs': 'FAQ 활성화',
  'dashboards.faqsDescription': 'FAQ를 활성화하면 웹 페이지 콘텐츠에서 시스템이 해당 답변을 추출하여 완전한 FAQ를 생성하는 동안 질문을 입력할 수 있습니다',
  'dashboards.faq': 'FAQ',
  'dashboards.deleteDocument': '문서 삭제',
  'dashboards.confirmDelete': '정말 삭제하시겠습니까?',
  'dashboards.addItem': '항목 추가',
  'dashboards.addFirstWebPage': '첫 번째 웹 페이지 추가',

  'dashboards.connect': '연결',
  'dashboards.tickets-by-category': '카테고리별 티켓',
  'dashboards.download': '다운로드',
  'dashboards.popular-compendium': '인기 컴펜디움 메뉴 항목',
  'dashboards.wordcloudofcompendium': '컴펜디움 메뉴 항목의 워드 클라우드',
  'dashboards.wordcloudonthings': '웹사이트 방문자가 묻는 내용 및 메뉴 항목에 대한 워드 클라우드',
  'dashboards.common-asked': '자주 묻는 질문',
  'dashboards.website-visitor-asking': '웹사이트 방문자가 궁금해하는 것들',
  'dashboards.contacts-prechatform-leavemessage':
    '사전 채팅 양식 및 메시지 남기기에서 저장된 연락처',
  'dashboards.visit-country': '국가별 웹사이트 방문',
  'dashboards.visit-traffic': '웹사이트 트래픽의 국가',
  'dashboards.rooms-product': '객실 및 제품',
  'dashboards.popular-room-product': '인기 객실 및 상품',
  'dashboards.subscribe-to-reports': '보고서 구독하기',
  'dashboards.messenger-stats': '인기 메뉴',
  'dashboards.messenger-stats-topic-view': '메뉴 항목 보기에 대한 통계',
  'dashboards.messenger-stats-visits': '메뉴 항목 보기',
  'dashboards.opening-menu-items': '메뉴 항목을 여는 웹사이트 방문자 수',

  'dashboards.number-totalavatarclick': '총 아바타 클릭',

  'dashboards.clicks': '클릭수',
  'dashboards.leads': '리드',
  'dashboards.hours': '시간',
  'dashboards.minutes': '분',

  'dashboards.ai-chatbot': 'AI 챗봇',
  'dashboards.compendium': '제요',
  'dashboards.compendium-digital-usage': '디지털 컴펜디엄 사용법',
  'dashboards.compendium-unique-visits': 'QR 코드 스캔/클릭',
  'dashboards.compendium-opening-menu-items': '본 메뉴 항목 수',
  'dashboards.compendium-total-digital-clicks': '총 메뉴 항목 조회수',
  'dashboards.compendium-total-qr-code': '총 QR 코드 스캔/클릭 수',
  'dashboards.compendium-avg-menu-items': '스캔당 평균 메뉴 항목 보기',


  'property.delete': '삭제',
  'menu.userroles': '사용자 및 역할',
  'menu.members': '회원',
  'menu.guest-pass': '게스트 패스',
  'menu.ratebookings': '요금 및 예약',
  'dashboards.engagement-time': '디지털 어시스턴트 참여 시간',
  'dashboards.conversations-minutes':
    '총 통화 시간 및 야간(오후 7시~오전 7시) 대화 시간',
  'dashboards.visitor-questions': '방문자 질문',
  'dashboards.recent-queries': '최근 검색어',
  'dashboards.visitor-saying': '방문자가 디지털 어시스턴트에게 말하는 것',
  'menu.dashboards': '인사이트',
  'menu.ari': '가용성 및 요금',
  'menu.conversations': '대화',
  'menu.conversations.unified-inbox': '통합받은 편지함',
  'menu.conversations.active': '활성 채팅',
  'menu.conversations.archives': '아카이브',
  'menu.conversations.missed-responses': '누락된 응답',
  'menu.conversations.ticket': '티켓',
  'menu.conversations.reply-templates': '회신 템플릿',
  'menu.bookings': '예약 및 예약',
  'menu.tickets': '리드 및 티켓',
  'menu.propinfo': '지식 허브',
  'menu.rate-promos': '요금 및 프로모션',
  'menu.finance': '재원',
  'menu.integration': '연결하다',
  'menu.admin': '관리 및 보안',
  'menu.favourites': '즐겨찾기',
  'menu.recommender': '대화 흐름',
  'menu.assistant-setup': '어시스턴트 설정',
  'menu.admin-insights': '관리자 통찰력',
  'menu.super-admin': '최고 관리자',
  'menu.groups': '여러 떼',
  'menu.properties': '속성',
  'menu.service-provider': '서비스 제공자',
  'menu.spaces': '공백',
  'menu.availability': '이용 가능 여부',
  'menu.help': '도움말',
  'menu.myAccounts': '내 계정',
  'menu.guest-messaging': '게스트 메시징',
  'guest-messaging.settings': '설정',
  'guest-messaging.outreach-setup': '아웃리치 설정',
  'guest-messaging.reservations': '예약',
  'guest-messaging.insights_logs': '인사이트 및 로그',
  'guest-messaging.placeholder': '게스트 메시징 모듈이 곧 제공됩니다.',
  'guest-messaging.settings.placeholder': '게스트 메시징 기본 설정을 지정하세요.',
  'guest-messaging.outreach.placeholder': '아웃리치 캠페인 및 템플릿을 설정하세요.',
  'guest-messaging.reservations.placeholder': '예약 메시지를 관리하세요.',
  'guest-messaging.reservation-source': '예약 데이터 소스',
  'guest-messaging.communication-channels': '커뮤니케이션 채널',
  'guest-messaging.templates': '템플릿',
  'guest-messaging.link': '링크',
  'guest-messaging.business-profile': '비즈니스 프로필',

  'dashboards.space-booking': '공간 예약',
  'dashboards.gift-voucher': '상품권',
  'dashboards.chatbots': '챗봇',
  'dashboards.form': '에서',
  'dashboards.to': '에게',
  'dashboards.active-groups': '활성 그룹',
  'dashboards.active-properties': '활성 속성',
  'dashboards.live-properties': '라이브 자산',
  'dashboards.properties-going': '날짜 범위별로 게시되는 속성',
  'dashboards.start-date': '시작일',
  'dashboards.end-date': '종료일',

  'dashboards.website-visits': '웹사이트 방문',
  'dashboards.unique-visitors': '순 방문자수',
  'dashboards.last-week': '지난주',
  'dashboards.this-week': '이번 주',
  'dashboards.this-month': '이번 달',
  'dashboards.previous-month': '지난달',
  'dashboards.yeartodate': '올해 초부터 현재까지',
  'dashboards.lastyear': '작년',
  'dashboards.last-7-days': '지난 7일',
  'dashboards.last-30-days': '지난 30일',
  'dashboards.last-60-days': '지난 60일',
  'dashboards.last-90-days': '지난 90일',
  'dashboards.conversion-rates': '전환율',
  'dashboards.digital-assistant-engagement': '디지털 어시스턴트 참여',
  'dashboards.total-overnight-conversations':
    '전체 및 하룻밤(오후 7시~오전 7시) 대화',
  'dashboards.percentage-accuracy': '정확도 이해',
  'dashboards.percentage-conversion': '웹사이트 트래픽을 채팅으로 전환',
  'dashboards.percentage-avatarclick': '아바타 클릭에 대한 웹사이트 트래픽',
  'dashboards.percentage-negativefeedback':
    '아바타 클릭 비율에 따른 부정적인 피드백',
  'dashboards.percentage-amenties': '어메니티 문의',
  'dashboards.percentage-booking': '예약문의',
  'dashboards.percentage-webchats': '웹사이트 채팅',
  'dashboards.percentage-facebookchat': '페이스북 채팅',
  //'dashboards.number-webchattime': '총 웹 채팅 시간',
  'dashboards.number-webchattime': '총 대화 시간',
  'dashboards.number-totalconversation': '총 대화',
  'dashboards.number-websiteconversation': '웹사이트 대화',
  'dashboards.number-facebookconversation': '페이스북 대화',
  'dashboards.number-estimatedtimesaving': '예상 시간 절약',
  'dashboards.number-googlemapsconversation': 'Google 지도 대화',
  'dashboards.number-whatsappconversation': 'WhatsApp 대화',
  'dashboards.number-instagramconversation': '인스타그램 대화',
  'dashboards.number-agentconversation': '에이전트 대화',
  'dashboards.number-amenityqueries': '어메니티 문의',
  'dashboards.number-bookingenquiries': '예약 문의',
  'dashboards.number-groupbookingenquiries': '단체예약문의',
  'dashboards.number-eventenquiries': '이벤트 문의',
  'dashboards.number-longstayenquiries': '장기 체류 문의',
  'dashboards.number-totaltickets': '티켓',
  'dashboards.number-returncustomer': '반품 고객',
  'dashboards.number-redirects': '웹사이트 리디렉션',
  'dashboards.number-bookingengineleads': '예약 엔진 리드',
  'dashboards.number-roomnightsreferred': '추천 객실 숙박',
  'dashboards.number-revenuereferred': '추천 수익',
  'menu.bookingsmenu': '예약',
  'menu.guests': '게스트 정보',
  'menu.whatsnew': '새로운 소식',

  'forms.forms-title': '양식',
  'menu.formbuilder': '양식 작성기',
  "dashboards.trainAI": "문서로 AI 훈련하기",
  "dashboards.uploadDocuments": "AI가 귀하의 비즈니스를 학습하고 고객을 귀하처럼 지원할 수 있도록 문서를 업로드하세요. .doc, .pdf 또는 .txt 형식의 파일을 추가할 수 있습니다.",
  'dashboards.welcomeMessage': '환영 메시지',
  'dashboards.personalizeGreeting': '고객이 환영받는 방식을 맞춤화하여 브랜드, 스타일, 예절을 반영하고 따뜻한 인사를 전하세요. 브랜드를 반영하는 인사말로 따뜻한 환영을 연출하세요.',
  'dashboards.addRoomDetails': '각 객실에 대한 세부 정보를 추가하여 투숙객이 완벽한 선택을 위해 필요한 모든 것을 쉽게 찾아보고 예약 절차를 더 간단하고 빠르게 만드세요.',
  'dashboards.trainAIFAQs': 'FAQ로 AI 훈련하기',
  'dashboards.manualQuestions': '일부 질문은 문서로 답할 수 없거나 웹사이트에서 찾을 수 없습니다. 여기에서 고객이 언제든지 필요한 정보를 얻을 수 있도록 수동으로 질문을 추가할 수 있습니다.',
  'dashboards.publishAI': '가장 최근 업데이트를 반영하도록 AI 게시하기',
  'dashboards.retrainAfterChanges': 'Knowledge Hub 또는 양식에 변경을 하면, 업데이트된 정보로 챗봇을 다시 학습시켜야 합니다. AI를 게시하면 챗봇이 가장 정확하고 최신의 답변을 제공할 수 있습니다.',
  'dashboards.enhanceKnowledge': '미응답 쿼리를 추적하여 AI 지식 강화',
  'dashboards.reviewUnanswered': 'AI가 질문에 답할 수 없거나 제한된 세부 정보만 제공할 경우, 이러한 쿼리는 여기에서 찾을 수 있습니다. 이를 검토하여 Knowledge Hub의 공백이나 고유한 고객 질문을 식별하세요.',
  'dashboards.manageMedia': '미디어 관리',
  'dashboards.mediaGallery': '객실, 시설, 로고 또는 디지털 아바타와 같은 이미지를 업로드할 때마다 이 갤러리에 표시됩니다. 시각 자료를 중앙에서 관리하고 손님이 비즈니스의 고유한 점을 볼 수 있도록 보장할 수 있는 장소입니다.',
  'dashboards.createForms': '양식을 쉽게 만들고 제출될 때마다 알림을 받으세요.',
  'dashboards.manageForms': '고객 정보를 수집하고 알림을 설정하며 여러 언어에 맞춰 양식을 맞춤 설정하기 위해 양식을 생성하고 관리하세요.',
  'dashboards.personalizeResponse': '응답 스타일과 대화 진행 방식을 개인화',
  'dashboards.controlConversation': '이 고급 기능을 통해 다양한 채널에서 고객과의 대화가 어떻게 전개되는지 형성하고 제어할 수 있는 기능을 제공합니다.',

  'menu.virtualfrontdesk': '가상 프런트 데스크',
  'menu.guestservice': '고객 서비스',
  'virtual-front.common-questions': '일반적인 질문',
  'virtual-front.add-on-upsells': '추가 기능 및 상향 판매',
  'virtual-front.service-order': '서비스 주문',
  //'virtual-front.guest-service-add-on-upsells': "게스트 서비스 및 애드온",
  'virtual-front.guest-service-add-on-upsells': '디지털 방명록',
  'virtual-front.outbound': '배 밖으로',
  'virtual-messenger': '전령',

  'missed-response.missed-response-title': '누락된 응답 제목',

  //
  'content.allconversation': '모든 대화',
  'content.active': '활성',
  'content.tickets': '티켓',
  'content.filter': '필터',
  'content.createtickets': '티켓 생성',
  'content.conversation': '대화',
  'content.knowledgesearch': '지식 검색',
  'content.reply': '답장',
  'content.visitorinfo': '방문자 정보',
  'content.callinfo': '통화 정보',
  'content.allinsights': '모든 인사이트',
  'content.availabilityrates': '가용성 및 요금',
  'content.callback': '콜백',
  'content.close': '닫기',
  'content.sms': 'SMS',
  'content.timestamp': '타임스탬프',
  'content.topics': '주제',
  'content.callingparty': '발신자',
  'content.accountdomain': '계정 도메인',
  'content.calledparty': '수신자',
  'content.recording': '녹음',
  'content.phonesystemoriginationcallid': '전화 시스템 발신 콜 ID',
  'content.phonesystemterminationcallid': '전화 시스템 종료 콜 ID',
  'content.uniqueconversationid': '고유 대화 ID',
  'content.regenerateinsights': '인사이트 재생성',
  'content.customersentiment': '고객 감정',
  'content.neutral': '중립',
  'content.customerreportedbroadbandoutage': '고객이 고객 ID와 서비스 활성화 날짜를 제공하며 광대역 장애를 신고했습니다.',
  'content.conversationinsights': '대화 인사이트',
  'content.broadbandoutage': '광대역 장애',
  'content.customeridverification': '고객 ID 확인',
  'content.serviceactivationdate': '서비스 활성화 날짜',
  'content.followups': '후속 조치',
  'content.actionneeded': '조치 필요',
  'content.uniqueConversationId': '고유 대화 ID',
  'content.uniqueChatId': '고유 채팅 ID',
  'content.recording&transcript': '녹음 및 대본',
  'content.chatinsights': '채팅 인사이트',
  'content.visitedpages': '방문한 페이지',
  'content.deviceinfo': '장치 정보',
  'content.chatstartedonthispage': '이 페이지에서 채팅 시작',
  'content.prechatinfo': '채팅 전 정보',
  'content.notes': '메모',
  'content.reassign': '재할당',
  'content.open': '열기',
  "content.dismiss": "닫기",
  "content.add_placeholder": "플레이스홀더 값 추가",
  "content.mobile_number": "휴대폰 번호",
  "content.please_select": "선택해 주세요",
  'content.sendwhatsapp': 'WhatsApp 메시지 보내기',



  /* Missed Response */
  'feedback.missed-question': '놓친 질문',
  'feedback.conversation-summary': '대화 요약',
  'feedback.dates-in-spanish': '날짜는 스페인어로 작성되어야 합니다',
  'feedback.resolve': '해결',
  'feedback.ignore': '무시',

  //integration
  // ko-KO
  'integration.select_properties': '속성 선택',
  'integration.select_properties_enabled': '이 통합을 통해 활성화된 속성 선택',
  'integration.services_addons': '서비스 및 애드온 선택',
  'integration.services_visible': '이 페이지에 표시될 서비스 및 애드온 선택',
  'integration.appearance': '모양',
  'integration.appearance_customize': '디지털 어시스턴트 이름, 아바타 및 색상 설정',
  'integration.booking_calendar': '예약 일정표',
  'integration.booking_calendar_style': '예약 일정표 팝업 스타일 선택',
  'integration.nudges': '알림',
  'integration.nudges_setup': '웹사이트 방문자에게 반응형 메시지 설정',
  'integration.position': '위치',
  'integration.position_control': '웹사이트에서 채팅 위젯 위치 제어',
  'integration.custom_fonts': '맞춤 글꼴',
  'integration.custom_fonts_upload': '페이지에 사용할 맞춤 글꼴 업로드',
  'integration.custom_css': '맞춤 CSS',
  'integration.custom_css_usage': 'CSS를 사용해 디지털 컴펜디움을 커스터마이즈',
  'integration.location': '위치',
  'integration.location_embed': '임베드 위치 URL 추가',
  'integration.external_links': '외부 링크',
  'integration.external_links_add': '링크 추가',
  'integration.language': '언어',
  'integration.widget_languages': '채팅 위젯 언어 선택',
  'integration.chatbot_contact': '챗봇',
  'integration.chatbot_enable': '디지털 어시스턴트 활성화',
  'integration.chatbot_security': '메신저를 안전하게 유지',
  'integration.chatbot_trusted_pages': '챗봇 표시를 위한 신뢰 페이지 목록',
  'integration.chatbot_publish': '디지털 어시스턴트 게시',
  'integration.chatbot_install': '디지털 어시스턴트를 설치할 코드 스니펫 복사',

};
export default koMessages;